<template>
  <div id="app">
    <router-view />
    <UserAgent></UserAgent>
  </div>
</template>
<script>
import UserAgent from "@/components/UserAgent";
export default {
  components: {
    UserAgent
  }
};
</script>
<style>
@font-face {
  font-family: "FZCSJW";
  src: url(./assets/font/FZCSJW.TTF);
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "方正黑体_GBK";
  src: url(./assets/font/方正黑体_GBK.TTF);
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "SourceSansVariable-Roman-subset";
  src: url(./assets/font/SourceSansVariable-Roman-subset.ttf);
  font-weight: normal;
  font-style: normal;
}
.upCoerImg {
  width: 100px;
}
.pageTitleController {
  display: flex;
  align-items: center;
  color: #0082a4;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
}
input,
button,
select,
textarea {
  outline: none;
}
* {
  margin: 0px;
  padding: 0px;
}
.width320 {
  width: 320px !important;
}

.marginLeft10 {
  margin-left: 10px;
}
.marginLeft20 {
  margin-left: 20px;
}
.marginLeft40 {
  margin-left: 40px;
}
.marginTop0 {
  margin-top: 0px;
}
.marginTop15 {
  margin-top: 15px;
}
.marginLeft15 {
  margin-left: 15px !important;
}
.marginTop8 {
  margin-top: 8px;
}
.marginTop20 {
  margin-top: 20px;
}
.marginTop30 {
  margin-top: 30px;
}
.marginTop40 {
  margin-top: 40px;
}
.marginBottom16 {
  margin-bottom: 16px;
}
.marginBottom0 {
  margin-bottom: 0px;
}
.marginBottom37 {
  margin-bottom: 37px;
}
.font400 {
  font-weight: 400;
}
.fixPass {
  position: relative;
}
.returnBtn {
  text-align: left;
  align-items: center;
}
</style>
<style lang="less">
// 保存按钮
.saveBtnController {
  display: inline-block;
  cursor: pointer;
  margin: auto;
  margin-top: 20px;
  width: 200px;
  height: 40px;
  border: 1px solid rgba(0, 130, 164, 1);
  color: rgba(0, 130, 164, 1);
  opacity: 1;
  border-radius: 20px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 40px;
  opacity: 1;
  text-align: center;
}
// 提交按钮
.subBtnController {
  display: inline-block;
  cursor: pointer;
  margin: auto;
  margin-top: 20px;
  width: 200px;
  height: 40px;
  background: rgba(0, 130, 164, 1);
  opacity: 1;
  border-radius: 20px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 40px;
  color: rgba(255, 255, 255, 1);
  opacity: 1;
  text-align: center;
}

// 圆形按钮
.yuanBtn {
  display: inline-block;
  cursor: pointer;
  margin-left: auto;
  margin-right: auto;
  padding: 0px 20px;
  height: 40px;
  background: rgba(0, 130, 164, 1);
  opacity: 1;
  border-radius: 20px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 40px;
  color: rgba(255, 255, 255, 1);
  opacity: 1;
  text-align: center;
}

// 圆形按钮2
.yuanBtn2 {
  display: inline-block;
  cursor: pointer;
  margin-left: auto;
  margin-right: auto;
  padding: 0px 20px;
  height: 40px;
  background: #00b1ff;
  opacity: 1;
  border-radius: 20px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 40px;
  color: rgba(255, 255, 255, 1);
  opacity: 1;
  text-align: center;
}

// 圆形镂空按钮
.yuanLouKongBtn {
  display: inline-block;
  cursor: pointer;
  margin-left: auto;
  margin-right: auto;
  padding: 0px 20px;
  height: 40px;
  opacity: 1;
  border-radius: 20px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 40px;
  border: 1px solid rgba(0, 130, 164, 1);
  color: rgba(0, 130, 164, 1);
  opacity: 1;
  text-align: center;
}
.delBtn {
  border: 1px solid #e6e6e6;
  color: #e6e6e6;
}
.total {
  display: flex;
}
.titleOverAll {
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: rgba(51, 51, 51, 1);
  opacity: 1;
  margin-bottom: 8px;
}
.title-s {
  font-size: 12px;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
}
.red {
  color: red;
}

.blueBorder {
  width: 200px;
  // height: 40px;
  border: 1px solid rgba(0, 130, 164, 1);
  opacity: 1;
  border-radius: 20px;
  background: rgba(0, 0, 0, 0) !important;
  font-size: 16px;
  font-weight: 400;
  color: rgba(0, 130, 164, 1);
  margin-top: 20px;
  // padding-top: 10px;
  // padding-bottom: 10px;
}
.noneBorder {
  width: 200px;
  height: 40px;
  border: 1px solid rgba(0, 130, 164, 1);
  opacity: 1;
  border-radius: 20px;
  background: rgba(0, 130, 164, 1) !important;
  font-size: 16px;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  margin-top: 20px;
  // padding-top: 10px;
  // padding-bottom: 10px;
}
// 上传按钮样式
.upBtn {
  text-align: center;
  cursor: pointer;
  border: 1px solid rgba(0, 130, 164, 1);
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  opacity: 1;
  height: 32px;
  line-height: 32px;
  padding: 0px 20px;
  background: rgba(0, 130, 164, 1);
  opacity: 1;
  border-radius: 2px;
}
// 页脚撑开
.footChengkai {
  display: inline-block;
  width: 30px;
}
// 一条分割线
.lines {
  width: 100%;
  background-color: #e6e6e6;
  height: 1px;
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>
